import analyticstracker from "@jmc/analyticstracker";
import { EventTypes } from "@jmc/core/src/types/EventTypes";
import { useEventListener } from "@jmc/utils/hooks/useEventListener";
import React, { useRef } from "react";

type Props = {
    children: JSX.Element | React.ReactNode;
    name?: string;
    linkname?: string;
};

export const BreadcrumbNavigationInteraction = (props: Props): JSX.Element => {
    const { linkname, name, children } = props;
    const ref = useRef<HTMLDivElement>(null);

    useEventListener(
        "click",
        (e: Event) => {
            analyticstracker().trackInteraction(e, {
                changeEvent: EventTypes.NAVIGATION_CLICK,
            });
        },
        ref,
    );

    return (
        <div
            data-tracking-event={EventTypes.NAVIGATION_CLICK}
            data-tracking-info={JSON.stringify({
                linkname,
                name,
            })}
            ref={ref}
        >
            {children}
        </div>
    );
};
